<template>
  <div class="box-big">
    <el-carousel indicator-position="outside" arrow="always" :autoplay='true' :pause-on-hover='false'>
      <el-carousel-item v-for="(item, index) in mydata.dataArr" :key="index">
        <div class="box-cards" style="cursor: pointer">
          <writingCards
            class="writing-cards"
            justify="center"
            v-for="(item2, index2) in item"
            :key="index2"
            :info="item2"
          ></writingCards>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script setup>
import writingCards from "./components/writingCards.vue";
import { reactive, watch } from "vue";
const props = defineProps({
  dataArr: {
    type: Array,
    default: () => {
      return [];
    },
  },
});

const mydata = reactive({
  dataArr: [],
});

watch(
  () => {
    return props.dataArr;
  },
  (n, o) => {
    // 暂时先写死吧
    if (n.length === 0) {
      mydata.dataArr = [];
    } else if (n.length > 0 && n.length <= 2) {
      mydata.dataArr = [n.slice(0, 2)];
    } else if (n.length > 2 && n.length <= 4) {
      mydata.dataArr = [n.slice(0, 2), n.slice(2, 4)];
    } else if (n.length > 4 && n.length <= 6) {
      mydata.dataArr = [n.slice(0, 2), n.slice(2, 4), n.slice(4, 6)];
    }
    // console.log("mydata.dataArr", mydata.dataArr);
  },
  {
    immediate: true,
  }
);
</script>

<style scoped lang="scss">
.box-big {
  width: 343px;
  height: 152px;
  margin: 0 auto;
  padding: 16px;
  // margin-bottom: 30px;
  border-radius: 8px;
  box-shadow: 0px 0px 20px 7px #0000001a;
  background-color: #ffffff;
  // border: 1px solid rgb(255, 0, 212);
}
.box-cards {
   margin: 0 auto;
  background-color: #ffffff;
  border-radius: 0px !important;
  // box-shadow: 0px 0px 20px 7px #0000001a;
  display: flex;
  // padding: 30px 0px;
  justify-content: space-between;
  // padding: 30px;
  // margin:30px;
  overflow: hidden;
  // border-radius: 8px;
  :deep(.writing-cards):nth-of-type(2n + 1) {
    border-right: 1px dashed #cccccc;
    padding-right: 21px;
  }
  :deep(.writing-cards):nth-of-type(2n) {
    margin-left: 21px;
    // padding-right:0px;
  }
  :deep(.writing-cards) {
    // width: 570px;
    // height: 100%;
    // border: 1px solid rgb(157, 255, 0);
    // border-radius: 0px !important;
    // padding-right:21px;
    // border-right:1px dashed #cccccc;
    // margin-left:21px;
    .bac-box {
      // background:transparent;
      // border:1px solid red;
    }
    .content-box{
      >p{
        margin-top:2px;
      }
    }
  }
}

// :deep(.box-writing){
   
// } 

//el-carousel元素
:deep(.el-carousel__container) {
  width: 100%;
  height: 120px;
  // padding:30px;
}

//每个元素激活时和激活后划走时得背景
:deep(.el-carousel__item.is-active.is-animating),
:deep(.el-carousel__item.is-animating) {
  // border:1px solid red;
  height: 120px;
  border-radius: 8px;
  background-color: transparent;
  // padding:30px;
}

//下面圆点
:deep(.el-carousel__indicator.el-carousel__indicator--horizontal) {
  > button {
    width: 9px;
    height: 9px;
    border-radius: 5px;
    margin-bottom: -10px;
  }
}
//下面整体圆点
:deep(
    .el-carousel__indicators.el-carousel__indicators--horizontal.el-carousel__indicators--outside
  ) {
  margin-top: 15px;
  // margin-bottom: 40px;
}
//两边箭头
:deep(.el-carousel__arrow.el-carousel__arrow--right) {
  width: 30px;
  height: 30px;
  // margin-left:-50px !important;
  // z-index: 100000;
  top: 60px;
  right: 0px;
  background: rgba(163, 169, 179, 0.3) !important;
  > i {
    font-size: 25px;
    font-weight: 700;
  }
}
:deep(.el-carousel__arrow.el-carousel__arrow--left) {
  width: 30px;
  height: 30px;
  left: 0px;
  top: 60px;
  background: rgba(163, 169, 179, 0.3) !important;
  > i {
    font-size: 25px;
    font-weight: 700;
  }
}
</style>
